export const SETTINGS_OBJ = {
  MinIdleLevel: 'MinIdleLevel',
  ReportInterval: 'ReportInterval',
  MaxWorkers: 'MaxWorkers',
  AutoSubscribe: 'AutoSubscribe',
  UpdateVersionOnSubscribe: 'UpdateVersionOnSubscribe',
  AllowSystemStandby: 'AllowSystemStandby',
  MinDiskFree: 'MinDiskFree',
  MinVirtualMem: 'MinVirtualMem',
  MinPhysicalMem: 'MinPhysicalMem',
  IgnoreProcesses: 'IgnoreProcesses',
  IgnoreFirewall: 'IgnoreFirewall',
  Port: 'Port',
  UpdateVersionAlways: 'UpdateVersionAlways',
  CheckForUpdatesOnline: 'CheckForUpdatesOnline',
  RunCacheCleanup: 'RunCacheCleanup',
  CacheCleanupInterval: 'CacheCleanupInterval',
  RunStatDBCleanup: 'RunStatDBCleanup',
  CleanDBPeriod: 'CleanDBPeriod',
  AutoSubscribeCloudNode: 'AutoSubscribeCloudNode',
  OfflinePeriodCloudNode: 'OfflinePeriodCloudNode',
  AgentsUseSecureConnections: 'AgentsUseSecureConnections',
  TelemetryEnabled: 'TelemetryEnabled',
  BuildGroups: 'BuildGroups',
  CoordinatorApiAccess: 'CoordinatorApiAccess',
  AllowAgentsSelfRegToBuildGroup: 'AllowAgentsSelfRegToBuildGroup',
  CoordAPIPort: 'CoordAPIPort',
  DashboardPort: 'DashboardPort',
  LicensePort: 'LicensePort',
  CoreLimits: 'CoreLimits',
  VersionUpdate: 'VersionUpdate',
  LastLicenseUpdate: 'LastLicenseUpdate',
  LastCacheCleared: 'LastCacheCleared',
  RabbitMqPort: 'RabbitMqPort',
  CoordApiPort: 'CoordApiPort',
  PrometheusPort: 'PrometheusPort',
  PrometheusEnabled: 'PrometheusEnabled',
  SSLPort: 'SSLPort',
  SslCnValidationPattern: 'SslCnValidationPattern',
  TelemetryDaysToSave: 'TelemetryDaysToSave',
  TelemetryDBMaxSize: 'TelemetryDBMaxSize',
  FloatingReleaseTime: 'FloatingReleaseTime',
  AutomaticBALicense: 'AutomaticBALicense',
  HelperCoresAssignmentPerc: 'HelperCoresAssignmentPerc',
  BackupCoordinator: 'BackupCoordinator',
  BackupCoordNames: 'BackupCoordNames',
  BackupCoordIPs: 'BackupCoordIPs',
  BackupCoordBuildNums: 'BackupCoordBuildNums',
  BackupCoordPorts: 'BackupCoordPorts',
  OtherCoordHost: 'OtherCoordHost',
  OtherCoordPort: 'OtherCoordPort',
  OtherCoordDisplay: 'OtherCoordDisplay',
  OtherCoordBuildNum: 'OtherCoordBuildNum',
};

// eslint-disable-next-line no-shadow
export const enum ActiveDirectoryStatus {
  azureADEnabled = 'Azure AD Connected',
  disabled = 'Not Connected',
  adEnabled = 'AD Connected',
}
